<template>   
    <router-view />
</template>

<script>
export default {
  name: "App",
  setup(){ 
   
    
  return {} 
  }
};
</script>
<style lang="scss" > // le escribi scoped porque si no no mostraba los inputs pero rompe el responsive nav :(
body {
  margin: 0;
  overflow-x: hidden !important; 
}
body::-webkit-scrollbar {
  width: 12px;  
  height: 20px;     
  }

body::-webkit-scrollbar-track {
  background: transparent;        /* color of the tracking area */
}

body::-webkit-scrollbar-thumb {
  background-color: #000D5A;    /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
  border: 1px solid #000;
    /* creates padding around scroll thumb */
}
.el-overlay{
   z-index: 99999 !important;
    background-color: transparent !important;
    backdrop-filter: blur(10px);
}
@font-face {
  font-family: "Yusei-Magic" ;
  src: url(./fonts/YuseiMagic-Regular.ttf) format("truetype");
}

@font-face {
  font-family: "SF-Compact-Display";
  src: url(./fonts/SF-Compact-Display-Regular.otf) format("truetype");
}

@font-face {
  font-family: "Avenir";
  src: url(./fonts/Metropolis-Regular.otf) format("truetype");
}

@font-face {
  font-family: "Avenir-light";
  src: url(./fonts/Metropolis-ExtraLight.otf) format("truetype");
}

@font-face {
  font-family: "Avenir-bold";
  src: url(./fonts/Metropolis-Bold.otf) format("truetype");
}

@font-face {
  font-family: "Poppins";
  src: url(./fonts/Poppins-Regular.ttf) format("truetype");
}

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 100vw;
}

#nav {
  padding: 0px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.navbar {
  margin-bottom: 10px;
  display: flex;
  position: fixed !important;
  width: 98% !important;
  z-index: 99999;
  background-image: url('./assets/navbar.png');
  background-repeat: no-repeat;
  border-bottom: 0px;
  background-size: 100% 100% ;
  height: 140px;
  background-color: transparent !important;
  text-align: center;
  margin-top: 10px !important;
  margin-left: 1vw !important;
}
.fondocms{
  background-image: url('./assets/fondocms.png');
  height: 100vh;
}
.navbar .el-menu.el-menu--horizontal {
  color: #fff !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border: 0px transparent !important;
  margin: auto;
  padding: 0;
  font-family: "Yusei-Magic";
  font-size: 24px;
  text-decoration: none;
  border-radius: 20px;
}
 .el-submenu__title:hover{
  background-color: #000D5A !important;
}
.el-menu.el-menu--horizontal {
  border: 0px transparent !important;

}

.demo .el-submenu__icon-arrow{
  visibility: hidden;
}
a:-webkit-any-link {
  text-decoration: none;
}
.soy{
    height: 90px !important;
    
    background-size: 100% 100%;
    background-image: url('./assets/hover.png');
    background-repeat: no-repeat;
}
.soy:hover{
  background-color: transparent !important ;
}
.nohov:hover, .nohov1:hover{
  background-color: transparent !important;
}
.nohov1 a{
  font-family:"SF-Compact-Display" ;
}
.el-carousel__arrow{
  width: 30px !important;
}
.el-carousel__arrow--left{
  background-size: 100% 100%;
  background-image: url('./assets/left.png');
  background-repeat: no-repeat;
  background-color: transparent !important;
}

.el-carousel__arrow--right{
  background-size: 101% 100%;
  background-image: url('./assets/right.png');
  background-repeat: no-repeat;
  background-color: transparent !important;
}
.forms {
  width: 98% !important;
  background-image: url('./assets/form.png');
  background-size: 100% 100%;
  z-index: 4;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 75px;
  margin: auto;
}

.cards {
  background-image: url('./assets/card.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 10px;
  margin-left: 10px;
  height: 240px;
  width: 20vw;
}

.modal {
  margin: auto;
  background-image: url('./assets/modal.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 101;
  width: 850px;
  height: 500px;
}

.el-input__inner {
  font-family: 'Avenir-light' !important;
  color: #ffffff !important;
  background-color: transparent !important;
  border: 2px solid #fff !important;
  height: 58px !important;
  width: 100%;
  padding-left: 15px;
  border-radius: 20px !important;
}
.el-input__inner::placeholder{
  color: #fff !important;
}
.forms .el-radio__inner{
  visibility: hidden;
  width: 45px;
  height: 45px;
}
.forms .el-radio.is-checked{
  border-bottom: 2px solid #fff;
}
.forms .el-radio__input.is-checked .el-radio__inner {
    border-color: transparent;
    background: transparent;
    background-image: url('./assets/check.svg') !important;
  background-color: transparent;
  background-repeat: no-repeat;
  visibility: visible;
}
.forms .el-radio__inner::after{
  width: 0px;
  height: 0px;
}
.forms .el-form-item__error{
  color: #000D5A;
}
.forms .el-radio__input.is-checked+.el-radio__label{
  color: #fff;
  font-size: 22px;
}
.forms .el-radio__label{
  font-size: 22px;
}
.in{
  width: 240% !important
} 
.notu{
  font-family: "Avenir-light";
  font-size: 22px;
}
.notu .el-form--inline .el-form-item__content{
  width: 200%;
}
.el-menu-vertical-demo {
  display: none;
}

.el-carousel__container{
  width: 99vw !important;
  background-color: transparent !important;
}
.el-carousel__item.is-active {
  margin-left: 7%;
}
.el-carousel__item[data-v-18aec612]:nth-child(2n+1){
  background-color: transparent !important ;
  width: 87%;
}
.el-carousel__item[data-v-18aec612]:nth-child(2n){
  background-color: transparent !important;
  margin-left: 5%;
}
.el-carousel__indicators{
  display: none;
}
.el-message-box{
  background-color: #000D5A !important;
  border-color:#000D5A !important ;
  color: #fff;
  border-radius:25px !important;

}
.el-message-box__content{
  color: #fff !important;
  font-family: 'Yusei-Magic';
  text-align: center;
  font-size: 22px;
  padding-top: 5vh !important;
}
.el-message-box__btns{
    text-align: center !important;
    background-color: #000D5A !important;   
    margin-bottom: 4vh; 
}
.el-message-box__btns .el-button{
  background-color: transparent;
  border:2px solid #fff;
  border-radius: 20px;
  width: 100px;
}

@media (max-width:1800px) {
  .el-menu--horizontal > .el-menu-item.is-active {
    font-size: 22px;
    margin-top: 1%;
  }
  .data1 .el-col-md-12{
    flex: 0 0 40%
  }
  .nohov1{
    margin-top: 1.1% !important;
  }
}
@media (max-width:1400px) {
  .el-menu--horizontal > .el-menu-item.is-active{
    margin-top: 1.5%;
  }
  
  .navbar{
    width: 98vw !important;
  }
  .el-radio__label{
            font-size:22px !important;
  }
  .in{
    width:240% !important;
  }
  .nohov1{
    margin-top: 1.6% !important;
  }
  
}
@media (max-width: 1024px) {
  .el-menu--horizontal > .el-menu-item.is-active {
  font-size: 18px;
    }
  .navbar {
    height: 120px;
  }
  .forms{
    margin-top: 0px;
  }
  .in{
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .navbar {
    display: none;
  }
  .el-menu-vertical-demo {
    display: block;
  }
  .el-menu {
    position: fixed !important;
    width: 100% !important;
    background-color: #000D5A !important;
    color: #fff !important;
    z-index: 999 !important;
  }
  .el-submenu__title {
    color: #fff !important;
  }
  .el-submenu [class^=el-icon-] {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 30px !important;
    color: #fff;
  }
  a {
    color: #fff !important;
    font-size: 20px;
  }
  .el-input__inner {
    margin-top: 15px !important;
  }
  .forms {
    background-size: cover;
  }
  .el-carousel__item.is-active {
  margin-left: 12% !important;
  }
  .el-carousel__container{
  width: 100vw !important;
  }
  .enlace a{
    color:#000D5A !important
  }
.el-icon-s-unfold{
         position: fixed;
    top: 15px;
    right: 20px;
    z-index: 9666;
    color: #fff;
    font-size: 25px;
   }
   
   .el-submenu.is-disabled .el-menu-item{
     opacity: 1 !important;
   }
}
 @media (max-width:500px) {
   .el-carousel__container{
     height: 1400px !important;
   }
   .el-carousel__item[data-v-18aec612]:nth-child(2n+1){
     widows: 76% !important;
   }

   .forms .el-radio:last-child {
    margin-right: 35px;
    }
    .chequer.is-checked{
      margin-right: 0px !important; 
    }
    .forms .el-radio.is-checked:last-child {
      margin-right: 10px;
   }
   
   .el-submenu .el-menu-item:last-child{
     height: 70px;
   }
   .el-message-box{
  width: 90% !important;
  border-color: #000D5A !important;
  border-radius: 25px !important;
}
 }
.table{
  margin-top: 50px !important; 
}
.el-table th, .el-table tr{
  background-color: #F3F5F9 !important;
  font-size: 20px;
  font-family: 'Avenir';
  color: #000D5A;
}

</style>
